var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { CurrencyRupee, Percent } from '@mui/icons-material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { PlusHeaderIcon } from '../../../assets/customIcons';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { getByIdAPI } from '../../../redux/crudSlice';
import { ContractInvoiceKeys, GetServiceContractDetailsURL } from '../services/entity';
var ContractDetailsDrawer = function (_ref) {
    var onClose = _ref.onClose, data = _ref.data;
    console.log("data.........", data);
    var dispatch = useDispatch();
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '16px 20px',
            columnSize: 12,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Contract details',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "secondary.600",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    size: 'icon',
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '20px',
            columnSize: 12,
            spacing: 0,
            borderTop: '1px solid',
            borderColor: 'secondary.200',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    border: '1px solid',
                    borderColor: 'secondary.200',
                    borderRadius: '12px',
                    padding: '16px',
                    gap: '12px',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'Code',
                                    value: null,
                                    columnSize: 0,
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    color: 'secondary.600'
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: '',
                                    label: 'New',
                                    size: 'small',
                                    sx: {
                                        borderRadius: '6px'
                                    },
                                    columnSize: 0
                                }]
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Name',
                            value: null,
                            columnSize: 12,
                            fontSize: 'lg',
                            fontWeight: 'medium',
                            valueGetter: function (formValues, field) {
                                return "Contract name- ".concat(formValues === null || formValues === void 0 ? void 0 : formValues.Name);
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'SAC Code:',
                            value: null,
                            fontWeight: 'medium',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'strong'
                            },
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'SacCode',
                            value: null,
                            columnSize: true
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Description',
                            value: null,
                            columnSize: 12,
                            fontSize: 'lg',
                            fontWeight: 'medium',
                            valueGetter: function (formValues, field) {
                                return "Description text- ".concat(formValues === null || formValues === void 0 ? void 0 : formValues.Description);
                            },
                            color: 'secondary.600'
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'OdometerReading',
                            value: null,
                            label: 'Odometer  ',
                            columnSize: 12,
                            placeholder: 'Enter odometer reading'
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'Amount',
                            label: 'Amount  ',
                            value: null,
                            columnSize: 12,
                            InputProps: {
                                startAdornment: /*#__PURE__*/ React.createElement(CurrencyRupee, {
                                    sx: {
                                        color: 'secondary.500',
                                        position: "start",
                                        height: '16px',
                                        width: '16px'
                                    }
                                }),
                                style: {
                                    textAlignLast: 'end'
                                }
                            },
                            valueGetter: function (formValues) {
                                return formValues === null || formValues === void 0 ? void 0 : formValues.TotalAmount;
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            alignItems: 'end',
                            elements: [{
                                    type: FormItemTypes.NumberInput,
                                    name: '',
                                    label: 'Discount',
                                    value: null,
                                    columnSize: 5,
                                    InputProps: {
                                        endAdornment: /*#__PURE__*/ React.createElement(Percent, {
                                            sx: {
                                                color: 'secondary.500',
                                                height: '16px',
                                                width: '16px'
                                            }
                                        })
                                    }
                                }, {
                                    type: FormItemTypes.NumberInput,
                                    name: '',
                                    label: '  ',
                                    value: null,
                                    columnSize: 7,
                                    InputProps: {
                                        startAdornment: /*#__PURE__*/ React.createElement(CurrencyRupee, {
                                            sx: {
                                                color: 'secondary.500',
                                                position: "start",
                                                height: '16px',
                                                width: '16px'
                                            }
                                        }),
                                        style: {
                                            textAlignLast: 'end'
                                        }
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 12,
                            borderRadius: '8px',
                            padding: '12px',
                            bgcolor: 'secondary.50',
                            display: 'flex',
                            flexDirection: 'column',
                            containerProps: {
                                spacing: 1
                            },
                            gap: '12px',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Renew conditions',
                                    fontWeight: 'strong',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    variant: 'fullWidth',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'RenewalEligibilityConditions',
                                    value: null,
                                    columnSize: 12,
                                    color: 'secondary.600'
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            paddingInline: '24px',
            columnSize: 12,
            height: '83px',
            padding: '24px',
            spacing: 0,
            gap: '12px',
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    direction: 'row',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'ContractPrice',
                            columnSize: 0,
                            fontSize: 'lg',
                            fontWeight: 'strong',
                            valueGetter: function (formValues, field) {
                                return "\u20B9 ".concat(formValues === null || formValues === void 0 ? void 0 : formValues.ContractPrice);
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'contained',
                            children: 'Add',
                            columnSize: 0,
                            startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        gridProps: {
            spacing: 0,
            sx: {
                paddingTop: {
                    sx: 0,
                    sm: 0,
                    md: '60px',
                    lg: '60px'
                }
            }
        },
        formData: formData,
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref2.request;
                onClose(request);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); },
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _res$payload, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                            key: ContractInvoiceKeys.GetServiceContractDetailsKey,
                            url: GetServiceContractDetailsURL(data === null || data === void 0 ? void 0 : data.id),
                            request: {}
                        }))];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, {
                                success: true,
                                data: _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 ? void 0 : _res$payload.data), data)
                            }];
                }
            });
        }); },
        mode: "edit"
    }));
};
export default ContractDetailsDrawer;
